export default "__VITE_ASSET__BWu1NUmS__"